module.exports = __webpack_public_path__ + "static/media/unidays.cf02bd43.png";